import { Building } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BuildingIcon = createLucideIcon(Building);
